import noahImg from "@/assets/story-noah.jpg";
import davidImg from "@/assets/story-david.jpg";
import danielImg from "@/assets/story-daniel.jpg";
import loavesImg from "@/assets/story-loaves.jpg";
import samaritanImg from "@/assets/story-samaritan.jpg";
import sheepImg from "@/assets/story-sheep.jpg";
import colorNoah from "@/assets/color-noah.jpg";
import colorDavid from "@/assets/color-david.jpg";
import colorDaniel from "@/assets/color-daniel.jpg";
import colorLoaves from "@/assets/color-loaves.jpg";
import colorSamaritan from "@/assets/color-samaritan.jpg";
import colorSheep from "@/assets/color-sheep.jpg";

export const STORY_IMAGES: Record<string, string> = {
  noah: noahImg,
  david: davidImg,
  daniel: danielImg,
  loaves: loavesImg,
  samaritan: samaritanImg,
  sheep: sheepImg,
};

export const COLORING_IMAGES: Record<string, string> = {
  noah: colorNoah,
  david: colorDavid,
  daniel: colorDaniel,
  loaves: colorLoaves,
  samaritan: colorSamaritan,
  sheep: colorSheep,
};
